import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSavingIndicatorStore = defineStore('ui', () => {
  const isSaving = ref(false)

  function indicateSaving() {
    isSaving.value = true
    // indicate a save action, then reset the state after {x} ms
    setTimeout(() => {
      isSaving.value = false
    }, 1000)
  }

  return { isSaving, indicateSaving }
})
